import { lazy } from "react";
import {
  Route,
  Routes,
  useParams,
  useSearchParams,
  useLocation
  
} from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import { useModal } from "../context/ModalContext";
import MetaTitle from "../component/MetaTitle";
// Lazy imports
const GameDetails = lazy(() => import("../pages/GameDetails"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Overview = lazy(() => import("../pages/MainContainer"));
const Favorites = lazy(() => import("../pages/Favorites"));
const AllGames = lazy(() => import("../pages/Overallgames"));

/**
 * ✅ Custom wrapper for /game/:gameId
 */
function GameRoute() {
  const { gamesdetails } = useModal();
  const { gameId } = useParams();

  // Still loading → don’t show NotFound yet
  if (!gamesdetails || gamesdetails.length === 0) {
    return <div className="loading">Loading...</div>; 
  }

  const game = gamesdetails.find(
    (g) => g.gamename.toLowerCase() === gameId.toLowerCase()
  );

  if (!game) {
    return <NotFound />;
  }

  return <GameDetails />;
}


/**
 * ✅ Custom wrapper for /games?category=...
 */
function GamesRoute() {
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category");

  const validCategories = ["live", "casino", "card", "table"];

  // If category exists but is invalid → show NotFound
  if (category && !validCategories.includes(category.toLowerCase())) {
    return <NotFound />;
  }

  return <AllGames category={category} />;
}

/**
 * ✅ App Routes
 */



export default function AppRoutes() {
  

 const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const categoryParam = searchParams.get("category");

  let category = "";
  let customTitle = "";

  if (categoryParam) {
    category = categoryParam;
  } else if (location.pathname === "/" || location.pathname === "/home") {
    customTitle = "Home";
  } else if (location.pathname === "/favorites") {
    customTitle = "Favorites";
  }

  return (
    <>
           <MetaTitle category={category} customTitle={customTitle} />
    <Routes>

      {/* Routes inside MainLayout */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Overview />} />
        <Route path="home" element={<Overview />} />

        {/* validate gameId */}
        <Route path="game/:gameId" element={<GameRoute />} />

        <Route path="favorites" element={<Favorites />} />

        {/* validate category */}
        <Route path="games" element={<GamesRoute />} />
      </Route>

      {/* fallback - OUTSIDE MainLayout */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  );
}
